export const SET_CREDITS = 'SET_CREDITS';
export const CREATE_CREDITS = 'CREATE_CREDITS';
export const SET_SELECTED_CREDITNOTE = 'SET_SELECTED_CREDITNOTE';
